module.exports = __webpack_public_path__ + "static/media/slide-img-3.3896cd3c.png";